import React from 'react';
import styled from 'styled-components';
import { maxWidth } from 'styled-system';

import Flex from 'Components/Base/Flex';

const Container = styled(({ ...restProps }) => <Flex px={4} mx={'auto'} {...restProps} />)`
  flex-direction: column;
  max-width: ${({ theme }) => theme.space.APP_MAX_WIDTH};
  ${maxWidth};
`;

Container.displayName = 'Container';

export default Container;
